import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getPartnerSplitSupplyNotice } from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'
import {
  GetPartnerSplitSupplyNoticeRequestSchema,
  type GetPartnerSplitSupplyNoticeResponse,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

import { type CivilDate, civilDateToProtoDate } from '~/models/civilDate'

/**
 * 他社の通告値 1 件の 48 コマ (全地点) の取得 hook。 ある受渡日 1 日分か、 'all' で期間全体
 * (月間の登録は対象月の全日。 受渡日を指定せずに取得する)。
 * id が無い (URL の query が壊れている) 間は取得しない。
 */
export function useGetPartnerSplitSupplyNotice(
  id: string | undefined,
  deliveryDate: CivilDate | 'all' | undefined,
): UseQueryResult<GetPartnerSplitSupplyNoticeResponse, ConnectError> {
  return useQuery(
    getPartnerSplitSupplyNotice,
    create(GetPartnerSplitSupplyNoticeRequestSchema, {
      id: id ?? '',
      deliveryDate:
        deliveryDate === undefined || deliveryDate === 'all'
          ? undefined
          : civilDateToProtoDate(deliveryDate),
    }),
    {
      enabled: id !== undefined && deliveryDate !== undefined,
      // 本番の既定は throwOnError: true (ErrorBoundary へ伝播)。 失敗は画面の中で案内するので伝播させない
      throwOnError: false,
    },
  )
}
